module.exports = __webpack_public_path__ + "img/link-sd.a13d9611.jpg";